import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import NotFoundComponent from '@widgets/not-found/NotFoundComponent'

import SEO from '@shared/components/SEO'
import { BRAND_NAME } from '@shared/contants/app'
import Container from '@shared/ui/container'
import Wrapper from '@shared/ui/wrapper'

import styles from './styles.module.scss'


export default function NoMatchPage () {
  const { t } = useTranslation('seo')
  useEffect(() => {
    document.documentElement.dataset.status = '404'
  }, [])

  return (
    <Container className={styles.container}>
      <SEO 
        title={t('notFound.title', { brand: BRAND_NAME })}
        description={t('notFound.description', { brand: BRAND_NAME })}
        keywords={t('notFound.keywords', { brand: BRAND_NAME })}
        ogTitle={t('notFound.title', { brand: BRAND_NAME })}
        ogDescription={t('notFound.description', { brand: BRAND_NAME })}
        noindex
      />
      <Wrapper>
        <NotFoundComponent />
      </Wrapper>
    </Container>
  )
}
